import React, { useEffect, useState } from "react";
import { Menu, X, ChevronDown } from "lucide-react";
import SwissFlag from "./SwissFlag";
import { NAV_LINKS } from "../mock";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState("#home");

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 60);
      const sections = ["#home", ...NAV_LINKS.map((l) => l.href)];
      let current = "#home";
      sections.forEach((id) => {
        const el = document.querySelector(id);
        if (el && el.getBoundingClientRect().top <= 120) current = id;
      });
      setActive(current);
    };
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (e, href) => {
    e.preventDefault();
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const dark = scrolled;

  return (
    <nav className={`nav-root ${scrolled ? "scrolled" : ""}`}>
      <div className="container mx-auto px-4 max-w-[1200px] flex items-center justify-between">
        {/* Logo */}
        <a href="#home" onClick={(e) => go(e, "#home")} className="flex items-center">
          <img
            src="/intelisoft-logo.png"
            alt="InteliSoft.ai"
            className="nav-logo"
            style={{ filter: dark ? "none" : "brightness(0) invert(1)" }}
          />
        </a>

        {/* Desktop menu */}
        <ul className="hidden lg:flex items-center gap-8">
          {NAV_LINKS.map((l) => (
            <li key={l.href}>
              <a
                href={l.href}
                onClick={(e) => go(e, l.href)}
                className={`nav-link-item ${active === l.href ? "active" : ""}`}
                style={{ color: dark ? "#141b34" : "rgba(255,255,255,0.92)" }}
              >
                {l.label}
              </a>
            </li>
          ))}
          <li className="dropdown relative group">
            <span
              className="nav-link-item flex items-center gap-1"
              style={{ color: dark ? "#141b34" : "rgba(255,255,255,0.92)" }}
            >
              Produkte <ChevronDown size={15} />
            </span>
            <ul className="absolute left-0 top-full pt-3 hidden group-hover:block">
              <div className="bg-white rounded-xl shadow-xl border border-slate-100 py-2 w-52">
                {["SaaS Portale", "CRM Systeme", "Dashboards", "Fachsoftware"].map((p) => (
                  <li key={p}>
                    <a
                      href="#overview"
                      onClick={(e) => go(e, "#overview")}
                      className="block px-5 py-2 text-sm text-slate-600 hover:text-[#1b6ef3] hover:bg-slate-50"
                    >
                      {p}
                    </a>
                  </li>
                ))}
              </div>
            </ul>
          </li>
        </ul>

        {/* Right actions */}
        <div className="hidden lg:flex items-center gap-4">
          <SwissFlag />
          <a
            href="#home"
            onClick={(e) => go(e, "#home")}
            className="nav-link-item"
            style={{ color: dark ? "#141b34" : "#fff" }}
          >
            Login
          </a>
          <a href="#contact" onClick={(e) => go(e, "#contact")} className="btn-theme sm">
            Anfragen
          </a>
        </div>

        {/* Mobile toggle */}
        <button
          className="lg:hidden p-2"
          onClick={() => setOpen(true)}
          style={{ color: dark ? "#141b34" : "#fff" }}
          aria-label="Menü öffnen"
        >
          <Menu size={26} />
        </button>
      </div>

      {/* Mobile drawer */}
      <div
        className={`fixed inset-0 z-[70] overflow-hidden transition ${open ? "visible" : "invisible pointer-events-none"}`}
      >
        <div
          className={`absolute inset-0 bg-black/50 transition-opacity ${open ? "opacity-100" : "opacity-0"}`}
          onClick={() => setOpen(false)}
        />
        <div
          className={`absolute right-0 top-0 h-full w-72 bg-white shadow-2xl p-6 transition-transform duration-300 ${
            open ? "translate-x-0" : "translate-x-full"
          }`}
        >
          <div className="flex items-center justify-between mb-8">
            <img src="/intelisoft-logo.png" alt="InteliSoft.ai" className="h-7 w-auto" />
            <button onClick={() => setOpen(false)} aria-label="Menü schliessen">
              <X size={24} />
            </button>
          </div>
          <ul className="flex flex-col gap-1">
            {NAV_LINKS.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  onClick={(e) => go(e, l.href)}
                  className="block py-3 border-b border-slate-100 font-medium text-slate-700"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
          <div className="mt-6 flex flex-col gap-3">
            <a href="#contact" onClick={(e) => go(e, "#contact")} className="btn-theme sm justify-center">
              Anfragen
            </a>
            <div className="swiss-badge dark self-start">
              <SwissFlag /> Made in Switzerland
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}
